<template>
    <div class="vsm-item" :class="[{'first-item' : firstItem}, {'open-item' : show}, {'active-item' : active}, {'parent-active-item' : childActive}]" @mouseenter="mouseEnter($event); showTitle()" @mouseleave="hiddenTitle()">
        <template v-if="!item.child">
            <template v-if="isRouterLink">
                <router-link class="vsm-link" :to="item.href" :disabled="item.disabled" @click.native="clickEvent">
                    <i v-if="item.icon" class="vsm-icon" :class="item.icon"></i>
                    <span v-if="!isCollapsed" class="vsm-title">{{item.title}}</span>
                </router-link>
            </template>
            <template v-else>
                <a class="vsm-link" :href="item.href" :disabled="item.disabled" @click="openMenu">
                    <i v-if="item.icon" class="vsm-icon" :class="item.icon"></i>
                    <span v-if="!isCollapsed" class="vsm-title">{{item.title}}</span>
                    <span v-if="itemSelected && isCollapsed" class="vsm-title-selected">{{item.title}}</span>
                </a>
            </template>
        </template>
        <template v-else>
            <div class="vsm-link" @click="toggleDropdown">
                <i v-if="item.icon" class="vsm-icon" :class="item.icon"></i>
                <template v-if="!isCollapsed">
                    <span class="vsm-title">{{item.title}}</span>
                    <i class="vsm-arrow" :class="{'open-arrow' : show}" ></i>
                </template>
            </div>
            <div class="vsm-dropdown" v-if="!isCollapsed">
                <transition name="show-animation">
                  <div class="vsm-list scrollbar-custon" :style="[{'overflow-y' : 'auto', 'height': item.child.length > 3 ? '295px' : 'auto'}]" v-if="show">
                        <sub-item v-for="(subItem, index) in item.child" :item="subItem" :key="index" />
                    </div>
                </transition>
            </div>
        </template>
    </div>
</template>

<script>
import SubItem from './SubItem.vue'
import { itemMixin } from './mixin'

export default {
  data() {
    return {
      show: false,
      itemSelected: false,
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    firstItem: {
      type: Boolean,
      default: false
    },
    isCollapsed: {
      type: Boolean
    }
  },
  components: {
    SubItem
  },
  mixins: [itemMixin],
  methods: {
    mouseEnter(event) {
      if (this.isCollapsed && this.firstItem) {
        this.$parent.$emit('mouseEnterItem', {
          item: this.item,
          pos:
            event.currentTarget.getBoundingClientRect().top -
            this.$parent.$el.getBoundingClientRect().top,
          height: this.$el.offsetHeight
        })
      }
    },
    clickEvent() {
      if (this.isCollapsed && this.firstItem) {
        this.$parent.$emit('clickItem')
      }
    },
    showTitle() {
      this.itemSelected = true;
    },
    hiddenTitle() {
      this.itemSelected = false;
    },
    openMenu() {
      this.hiddenTitle();
      this.$parent.$emit('showMenu', { 
          item: this.item,
          pos: event.currentTarget.getBoundingClientRect().top - this.$parent.$el.getBoundingClientRect().top,
          height: this.$el.offsetHeight 
      });
    }
  }
}
</script>

